<template>
  <div class="chat-list-wrapper">
    <el-row v-loading="fetchResolvedChatLoading">
      <!-- Empty chat message -->
      <el-row
        v-if="!resolvedChatsArray || resolvedChatsArray.length === 0"
        style="position: relative"
      >
        <p>There are currently no resolved chats.</p>
      </el-row>

      <el-row
        class="chat-list-item"
        @click.native="selectChat(chat.RowKey, chat.interactions?.length || 0)"
        v-for="(chat, index) in resolvedChatsArray"
        :key="index"
      >
        <el-tooltip class="list-item" effect="dark" placement="right">
          <div slot="content" style="max-width: 400px">
            <ResolvedTooltip :chat="chat" />
          </div>

          <el-row
            class="list-item"
            type="flex"
            :class="getChatClass(index, chat, selectedChatId)"
            style="margin-bottom: 0"
          >
            <!-- Avatar -->
            <el-col style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              <el-row type="flex" style="margin-bottom: 0; align-items: center">
                <!-- <ChatAvatar :chat="chat" style="display: inline-block" /> -->
                <el-col
                  style="
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <div class="chat-name">
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                      {{ getChatName(chat) }}
                    </span>
                  </div>
                  <el-row style="margin-top: 4px" v-if="getTagName(chat.stateVariables)">
                    <CustomColorTag :color="getTagColor(getTagName(chat.stateVariables))" size="mini">{{
                      getTagName(chat.stateVariables)
                    }}</CustomColorTag>
                  </el-row>
                </el-col>
              </el-row>
              <el-row style="font-size: 16px">
                <div class="chat-item-meta" v-if="chat.agents.length > 0">
                  <span>Attended by {{ chat.agents.join(", ") }}</span>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-tooltip>
      </el-row>
      <el-row>
        <div
          v-loading="showMoreIsLoading"
          element-loading-spinner="el-icon-loading"
          v-if="resolvedChatsArray && resolvedChatsArray.length > 0 && !hasNoMoreChats"
          class="prev-conversation"
          @click="$emit('fetchMoreResolvedChats')"
        >
          - show more -
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import ResolvedTooltip from "./Tooltip";
import ChatAvatar from "@/components/LiveChat/ChatAvatar";
import CustomColorTag from "@/components/LiveChat/CustomColorTag";
import { mapGetters } from "vuex";
import moment from "moment";
import map from "lodash/map";
import get from "lodash/get";
import { getChatName, getTagName, tagType, getTagColor } from "@/filters/index";

import {
  getAvatar,
  getChatClass,
  getDisplayId,
  getPreview,
  printDuration,
} from "@/helperMethods/livechat/util";

export default {
  props: {
    selectedIndex: Number,
    showMoreIsLoading: {},
    hasNoMoreChats: {},
  },
  components: {
    ResolvedTooltip,
    ChatAvatar,
    CustomColorTag,
  },
  data() {
    return {
      waitedTime: [],
      pageNo: 0,
      tab: "resolved",
    };
  },
  computed: {
    ...mapGetters([
      "fetchResolvedChatLoading",
      "resolvedChatsArray",
      "resolvedChatFilters",
      "selectedChatId",
    ]),
  },
  methods: {
    getAvatar,
    getDisplayId,
    getChatClass,
    getPreview,
    get,
    getChatName,
    getTagName,
    tagType,
    getTagColor,

    selectChat(chatId, interactionsLength) {
      this.$set(this.$store.state.livechat, "selectedChatId", chatId);
      this.$store.commit("SELECT_LIVE_CHAT", { chatId, type: "resolved" });
      if (interactionsLength < 10) {
        this.$emit("on-init-fetch-interaction");
      }
    },

    calculateWaitedTime() {
      this.waitedTime = map(this.resolvedChatsArray, (chat) => {
        return printDuration(chat.startQueueTime, moment().format());
      });
    },
  },
  mounted() {
    this.calculateWaitedTimeInterval = setInterval(() => {
      this.calculateWaitedTime();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.calculateWaitedTimeInterval);
  },
  filters: {
    humanize(value) {
      return moment(value).fromNow();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/chat-list.scss";
</style>
